import { Investment, InvestmentQuote } from "@rentablo/api/apiv1";
import { DashboardGainersAndLosersData } from "../components/Dashboard/DashboardGainersAndLosers/types";

export type GainerLoserInvestment = Pick<Investment, "id" | "name"> & {
  quote?: Pick<InvestmentQuote, "changePercentAbs">;
};

const EXPECTED_NUMBER_OF_ITEMS = 4;

export const prepareGainersAndLosers = (
  gainerInvestments: GainerLoserInvestment[] = [],
  loserInvestments: GainerLoserInvestment[] = []
): DashboardGainersAndLosersData => {
  if (!gainerInvestments.length && !loserInvestments.length)
    return { gainers: [], losers: [] };

  const gainers = gainerInvestments.map(({ id, name, quote }) => ({
    id,
    name,
    value: quote?.changePercentAbs ?? 0,
  }));

  const losers = loserInvestments.map(({ id, name, quote }) => ({
    id,
    name,
    value: quote?.changePercentAbs ?? 0,
  }));

  if (
    losers.length >= EXPECTED_NUMBER_OF_ITEMS &&
    gainers.length >= EXPECTED_NUMBER_OF_ITEMS
  ) {
    return {
      gainers: gainers.slice(0, EXPECTED_NUMBER_OF_ITEMS),
      losers: losers.slice(0, EXPECTED_NUMBER_OF_ITEMS),
    };
  }
  if (
    losers.length < EXPECTED_NUMBER_OF_ITEMS &&
    gainers.length < EXPECTED_NUMBER_OF_ITEMS
  ) {
    return {
      gainers,
      losers,
    };
  }

  if (losers.length < EXPECTED_NUMBER_OF_ITEMS) {
    const needed =
      EXPECTED_NUMBER_OF_ITEMS + (EXPECTED_NUMBER_OF_ITEMS - losers.length);
    return {
      gainers: gainers.slice(0, needed),
      losers,
    };
  }

  const needed =
    EXPECTED_NUMBER_OF_ITEMS + (EXPECTED_NUMBER_OF_ITEMS - gainers.length);
  return {
    losers: losers.slice(0, needed),
    gainers,
  };
};
